import { Box, Button, Divider, Typography } from "@mui/material";
import { selectConditions } from "features/homepage/saga/homepageSlice";
import { selectStoreDetail } from "features/searchStore/saga/searchStoreSlice";
import { useRef, useState } from "react";
import { useAppSelector } from "redux/hooks";

const strList1 = [
  "ARK Hills (アークヒルズ) ディナー",
  "東京タワーディナー",
  "西久保八幡神社 ディナー",
  "愛宕神社 ディナー",
  "東京タワー水族館 ディナー",
  "虎ノ門ヒルズ ディナー",
  "泉屋博古館分館 ディナー",
  "菊池寛実記念智美術館 ディナー",
  "サントリーホール ディナー",
  "NHK放送博物館 ディナー",
  "泉ガーデンタワー ディナー",
  "住友不動産六本木グランドタワーディナー",
  "Taka Ishii Gallery Photography/Film ディナー",
  "増上寺 ディナー",
  "青松寺 ディナー",
  "虎ノ門金刀比羅宮 ディナー",
  "ThePlaceofTokyo (ザプレイスオブトウキョウ) ディナー",
  "東京ワンピースタワー ディナー",
  "六本木一丁目駅 ディナー",
  "神谷町駅 ディナー",
  "御成門駅 ディナー",
  "アンダーズ東京 ディナー",
  "ANAインターコンチネンタルホテル東京 ディナー",
  "ホテルオークラ東京 (別館) ディナー",
  "東京プリンスホテルディナー",
  "ヴィラフォンテーヌ グランド 東京六本木",
  "住友不動産 ディナー",
  "東京虎ノ門東急REIホテルディナー",
  "京王プレッソイン浜松町 ディナー",
  "アパホテル〈六本木一丁目駅前〉 (2020年7月からアパホテル 〈六本木SIX>) ディナー",
  "The Okura Tokyo ディナー",
];

const strList2 = [
  "東京 グルメ・レストラン ランキング",
  "神谷町 グルメ・レストラン ランキング",
  "東京 ランチ ランキング",
  "神谷町 ランチ ランキング",
  "東京 ディナー ランキング",
  "神谷町 ディナー ランキング",
];

export function RelatedCategorySection() {
  const [expanded1, setExpanded1] = useState(false);
  const [expanded2, setExpanded2] = useState(false);
  const [expanded3, setExpanded3] = useState(false);

  const boxRef1 = useRef<HTMLDivElement>(null);
  const boxRef2 = useRef<HTMLDivElement>(null);
  const boxRef3 = useRef<HTMLDivElement>(null);

  const contentBox1Overflows = () => {
    if (boxRef1.current) {
      return boxRef1.current.scrollHeight > boxRef1.current.clientHeight;
    }
    return false;
  };

  const contentBox2Overflows = () => {
    if (boxRef2.current) {
      return boxRef2.current.scrollHeight > boxRef2.current.clientHeight;
    }
    return false;
  };

  const contentBox3Overflows = () => {
    if (boxRef3.current) {
      return boxRef3.current.scrollHeight > boxRef3.current.clientHeight;
    }
    return false;
  };

  const storeData = useAppSelector(selectStoreDetail);
  return (
    <Box display="flex" width="100%" justifyContent="center">
      <Box display="flex" flexDirection="column" width="1000px">
        <Box my={2}>
          <Typography fontWeight="bold" variant="h5" sx={{ my: 2 }}>
            条件の似たレストランを探す
          </Typography>
          <Box display="flex" flexWrap="wrap" ref={boxRef1}>
            {storeData.Conditions.map((str, index) => (
              <Box
                key={index}
                display="flex"
                width="max-content"
                alignItems="center"
                p={1}
              >
                <Typography
                  color="#696969"
                  sx={{
                    cursor: "pointer",
                    "&:hover": {
                      color: "black",
                    },
                    px: 1,
                    borderRight:
                      index !== storeData.Conditions.length - 1 ? 1 : 0,
                  }}
                >
                  {str}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>

        <Box my={2}>
          <Typography fontWeight="bold" variant="h5" sx={{ my: 2 }}>
            近隣のスポットから探す
          </Typography>
          <Box
            display="flex"
            flexWrap="wrap"
            // overflow="hidden"
            // height={expanded2 ? "auto" : "125px"}
            ref={boxRef2}
          >
            {strList1.map((str, index) => (
              <Box
                key={index}
                display="flex"
                width="max-content"
                alignItems="center"
                p={1}
              >
                <Typography
                  color="#696969"
                  sx={{
                    cursor: "pointer",
                    "&:hover": {
                      color: "black",
                    },
                    px: 1,
                    borderRight: index !== strList1.length - 1 ? 1 : 0,
                  }}
                >
                  {str}
                </Typography>
              </Box>
            ))}
          </Box>
          <Box>
            {!contentBox2Overflows() && (
              <Button
                onClick={() => {
                  const prev = expanded2;
                  setExpanded2(!prev);
                }}
                variant="contained"
                sx={{
                  position: "absolute",
                  bottom: 0,
                  right: 0,
                  display: "block",
                  visibility: expanded2 ? "visible" : "hidden",
                }}
              >
                Expand
              </Button>
            )}
          </Box>
        </Box>

        <Box my={2}>
          <Typography fontWeight="bold" variant="h5" sx={{ my: 2 }}>
            近隣のエリアのランキングをみる
          </Typography>
          <Box display="flex" flexWrap="wrap" ref={boxRef3}>
            {strList2.map((str, index) => (
              <Box
                key={index}
                display="flex"
                width="max-content"
                alignItems="center"
                p={1}
              >
                <Typography
                  color="#696969"
                  sx={{
                    cursor: "pointer",
                    "&:hover": {
                      color: "black",
                    },
                    px: 1,
                    borderRight: index !== strList2.length - 1 ? 1 : 0,
                  }}
                >
                  {str}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
